import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "../utils/axiosInstance";
import {
  Modal,
  Button,
  Form,
  Table,
  Row,
  Col,
  Card,
  Badge,
  Spinner,
  Alert,
  InputGroup,
  Pagination,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { getApiBase } from "../utils/useApiBase";
const API_URL = `${getApiBase()}/ingo`;

const Ingo = ({ isUmudugudu = false }) => {
  // ────────────────────────────────────────────────
  // Core States
  // ────────────────────────────────────────────────
  const [ingoList, setIngoList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedHousehold, setSelectedHousehold] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [filterUbudehe, setFilterUbudehe] = useState("all");
  const [filterWater, setFilterWater] = useState("all");
  const [filterElectricity, setFilterElectricity] = useState("all");
  const [filterHomeType, setFilterHomeType] = useState("all");
  const [filterInsurance, setFilterInsurance] = useState("all");
  const [filterMutuelle, setFilterMutuelle] = useState("all");
  // Year the Mutuelle payment status is shown/tracked for.
  const [insuranceYear, setInsuranceYear] = useState(new Date().getFullYear());
  // Edit modal: whether "Mituweli yishyuwe" is ticked for `insuranceYear`.
  const [mutuellePaid, setMutuellePaid] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stats, setStats] = useState({
    total: 0,
    totalMembers: 0,
    avgMembersPerHouse: 0,
    withWater: 0,
    withElectricity: 0,
    ownedHouses: 0,
    rentedHouses: 0,
    ubudeheArakennye: 0,
    ubudeheArifashije: 0,
    ubudeheAracyize: 0,
  });
  const [form, setForm] = useState({
    umukuru_w_urugo: "",
    household_head_citizen_id: "",
    umubare_w_abagize: "",
    aho_batuye: "",
    ubwoko_bw_inzu: "",
    bafite_amazi: "",
    bafite_umuyoboro_wamashanyarazi: "",
    icyiciro_cy_imibereho: "",
    umudugudu: "",
    akagari: "",
    umurenge: "",
    akarere: "",
    izina_ry_isibo: "",
    ubwishingizi: "",
    ubwishingizi_bwihariye: "",
    telefone_umukuru: "",
    indangamuntu_umukuru: "",
  });
  const [formErrors, setFormErrors] = useState({});

  // ── Household Members ────────────────────────────────────
  const [showMembers, setShowMembers] = useState(false);
  const [membersHousehold, setMembersHousehold] = useState(null);
  const [memberNames, setMemberNames] = useState([]);
  const [memberIds, setMemberIds] = useState([]); // parallel to memberNames — real household_members.id or null for a not-yet-saved slot
  const [savedMembers, setSavedMembers] = useState({});
  const [membersLoading, setMembersLoading] = useState(false);
  const firstMemberRef = useRef(null);

  // ─── Responsive States ──────────────────────────────────
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [windowHeight, setWindowHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 800
  );
  const [orientation, setOrientation] = useState(
    typeof window !== "undefined" && window.innerWidth > window.innerHeight
      ? "landscape"
      : "portrait"
  );
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [useCardView, setUseCardView] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const topRef = useRef(null);
  const tableRef = useRef(null);

  // ─── Breakpoints ────────────────────────────────────────
  const isExtraSmall = windowWidth <= 360;
  const isSmall = windowWidth <= 576;
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;
  const isDesktop = windowWidth > 1024;
  const isLandscape = orientation === "landscape";
  const isShortScreen = windowHeight <= 500;

  // ─── Theme — Government Light Design System ─────────────
  const theme = {
    bg: "#f8fafc",
    bgSecondary: "#f1f5f9",
    card: "#ffffff",
    text: "#374151",
    textBright: "#0f172a",
    textMuted: "#64748b",
    primary: "#1e3a5f",
    primaryLight: "#eff6ff",
    success: "#16a34a",
    successLight: "#f0fdf4",
    warning: "#d97706",
    warningLight: "#fffbeb",
    danger: "#dc2626",
    dangerLight: "#fff1f2",
    info: "#1d4ed8",
    infoLight: "#eff6ff",
    border: "#e2e8f0",
    borderLight: "#f1f5f9",
  };

  const ubudeheCategories = [
    { value: "Arakennye", label: "Arakennye", color: "danger", icon: "exclamation-triangle-fill" },
    { value: "Arifashije", label: "Arifashije", color: "warning", icon: "dash-circle-fill" },
    { value: "Aracyize", label: "Aracyize", color: "success", icon: "check-circle-fill" },
  ];

  // ─── Insurance (Ubwishingizi) ──────────────────────────
  // Predefined schemes; "Ibindi" reveals a free-text field for anything else.
  const INSURANCE_TYPES = [
    "Mituweli", "RSSB", "RAMA", "MMI", "Radiant", "Britam", "Prime", "Ibindi",
  ];
  const INSURANCE_YEAR_NOW = new Date().getFullYear();
  // Year <select> options: current year down to 5 years back.
  const insuranceYearOptions = Array.from(
    { length: 6 },
    (_, i) => INSURANCE_YEAR_NOW - i
  );

  // ─── Responsive Detection ──────────────────────────────
  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      setWindowWidth(w);
      setWindowHeight(h);
      setOrientation(w > h ? "landscape" : "portrait");

      if (w <= 576) {
        setItemsPerPage(5);
        setUseCardView(true);
      } else if (w <= 768) {
        setItemsPerPage(8);
        setUseCardView(true);
      } else {
        setItemsPerPage(10);
        setUseCardView(false);
      }
    };

    const handleOrientationChange = () => setTimeout(handleResize, 150);

    const handleFocusIn = (e) => {
      if (
        e.target.tagName === "INPUT" ||
        e.target.tagName === "TEXTAREA" ||
        e.target.tagName === "SELECT"
      ) {
        if (window.innerWidth <= 768) setKeyboardVisible(true);
      }
    };

    const handleFocusOut = () => setKeyboardVisible(false);

    const handleViewportResize = () => {
      if (window.visualViewport) {
        setKeyboardVisible(
          window.visualViewport.height < window.innerHeight * 0.75
        );
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleViewportResize);
    }

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleViewportResize);
      }
    };
  }, []);

  // ─── Viewport & Safe Area ──────────────────────────────
  useEffect(() => {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      document.head.appendChild(viewportMeta);
    }
    viewportMeta.content =
      "width=device-width, initial-scale=1, maximum-scale=1, " +
      "user-scalable=no, viewport-fit=cover";

    let themeMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeMeta) {
      themeMeta = document.createElement("meta");
      themeMeta.name = "theme-color";
      document.head.appendChild(themeMeta);
    }
    themeMeta.content = theme.bg;

    
    document.body.style.backgroundColor = theme.bg;

    return () => {
      document.body.style.overscrollBehavior = "";
    };
  }, []);

  // ────────────────────────────────────────────────
  // Helpers
  // ────────────────────────────────────────────────
  const isYego = (val) => {
    if (!val) return false;
    const v = val.toString().toLowerCase().trim();
    return v === "yego" || v === "yes" || v === "true" || v === "1";
  };

  const getYegoOyaText = (v) => (isYego(v) ? "Yego" : "Oya");
  const getYegoOyaColor = (v) => (isYego(v) ? "success" : "danger");
  const getYegoOyaIcon = (v) => (isYego(v) ? "check-circle-fill" : "x-circle-fill");

  // Mutuelle status pill for a household, scoped to `insuranceYear`.
  // Returns null for households whose insurance is not Mituweli.
  const mutuelleBadge = (h) => {
    if ((h?.ubwishingizi || "") !== "Mituweli") return null;
    const paid = !!h.mutuelle_yishyuwe;
    return {
      paid,
      text: `Mutuelle ${insuranceYear}: ${paid ? "Yishyuwe" : "Ntabwo Yishyuwe"}`,
      color: paid ? "success" : "danger",
    };
  };
  // Insurance type shown to the user (custom name when "Ibindi").
  const insuranceLabel = (h) =>
    (h?.ubwishingizi === "Ibindi" && h?.ubwishingizi_bwihariye)
      ? h.ubwishingizi_bwihariye
      : (h?.ubwishingizi || "—");

  const calculateStats = (data) => {
    if (!data?.length) {
      setStats({
        total: 0, totalMembers: 0, avgMembersPerHouse: 0,
        withWater: 0, withElectricity: 0, ownedHouses: 0,
        rentedHouses: 0, ubudeheArakennye: 0,
        ubudeheArifashije: 0, ubudeheAracyize: 0,
      });
      return;
    }
    const totalMembers = data.reduce(
      (sum, h) => sum + Number(h.umubare_w_abagize || 0), 0
    );
    setStats({
      total: data.length,
      totalMembers,
      avgMembersPerHouse: (totalMembers / data.length).toFixed(1),
      withWater: data.filter((h) => isYego(h.bafite_amazi)).length,
      withElectricity: data.filter((h) =>
        isYego(h.bafite_umuyoboro_wamashanyarazi)
      ).length,
      ownedHouses: data.filter((h) => h.ubwoko_bw_inzu === "Iyabo").length,
      rentedHouses: data.filter((h) => h.ubwoko_bw_inzu === "Ikodeshejwe")
        .length,
      ubudeheArakennye: data.filter(
        (h) => h.icyiciro_cy_imibereho === "Arakennye"
      ).length,
      ubudeheArifashije: data.filter(
        (h) => h.icyiciro_cy_imibereho === "Arifashije"
      ).length,
      ubudeheAracyize: data.filter(
        (h) => h.icyiciro_cy_imibereho === "Aracyize"
      ).length,
    });
  };

  const showAlertMessage = (msg, variant = "success") => {
    setAlert({ show: true, message: msg, variant });
    setTimeout(() => setAlert({ show: false, message: "", variant: "" }), 4500);
  };

  const resetForm = () => {
    setForm({
      umukuru_w_urugo: "", household_head_citizen_id: "", umubare_w_abagize: "", aho_batuye: "",
      ubwoko_bw_inzu: "", bafite_amazi: "",
      bafite_umuyoboro_wamashanyarazi: "",
      icyiciro_cy_imibereho: "", umudugudu: "",
      akagari: "", umurenge: "", akarere: "",
      izina_ry_isibo: "", ubwishingizi: "", ubwishingizi_bwihariye: "",
      telefone_umukuru: "", indangamuntu_umukuru: "",
    });
    setFormErrors({});
    setEditingId(null);
    setMutuellePaid(false);
  };

  // ────────────────────────────────────────────────
  // Actions
  // ────────────────────────────────────────────────
  const exportToCSV = () => {
    if (filteredData.length === 0) {
      showAlertMessage("Nta makuru yo kohereza", "warning");
      return;
    }
    const headers = [
      "Umukuru w'Urugo", "Umubare w'Abagize", "Aho Batuye",
      "Ubwoko bw'Inzu", "Bafite Amazi", "Amashanyarazi",
      "Icyiciro cy'Ubudehe", "Umudugudu", "Akagari",
      "Umurenge", "Akarere", "Ubwishingizi",
      `Mutuelle ${insuranceYear}`, `Itariki yishyuriweho ${insuranceYear}`,
    ];
    const csvData = filteredData.map((h) => [
      h.umukuru_w_urugo || "", h.umubare_w_abagize || "",
      h.aho_batuye || "", h.ubwoko_bw_inzu || "",
      getYegoOyaText(h.bafite_amazi),
      getYegoOyaText(h.bafite_umuyoboro_wamashanyarazi),
      h.icyiciro_cy_imibereho || "", h.umudugudu || "",
      h.akagari || "", h.umurenge || "", h.akarere || "",
      insuranceLabel(h) === "—" ? "" : insuranceLabel(h),
      h.ubwishingizi === "Mituweli" ? (h.mutuelle_yishyuwe ? "Yishyuwe" : "Ntabwo Yishyuwe") : "",
      (h.ubwishingizi === "Mituweli" && h.mutuelle_yishyuwe && h.mutuelle_itariki)
        ? new Date(h.mutuelle_itariki).toLocaleDateString("rw-RW") : "",
    ]);
    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    );
    link.download = `ingo_${new Date().toISOString().split("T")[0]}.csv`;
    link.click();
    showAlertMessage("Amakuru yakoreshejwe neza!", "success");
  };

  const handleViewDetails = (household) => {
    setSelectedHousehold(household);
    setShowDetails(true);
  };

  const handleEdit = (household) => {
    setForm({
      umukuru_w_urugo: household.umukuru_w_urugo || "",
      household_head_citizen_id: household.household_head_citizen_id || "",
      umubare_w_abagize: household.umubare_w_abagize || "",
      aho_batuye: household.aho_batuye || "",
      ubwoko_bw_inzu: household.ubwoko_bw_inzu || "",
      // The DB's `bafite_amazi` column is a lowercase-only ENUM ('yego'/'oya'),
      // but the <Form.Select> below uses capitalized option values ("Yego"/"Oya").
      // Normalize case here so the saved value actually matches an option.
      bafite_amazi: household.bafite_amazi ? getYegoOyaText(household.bafite_amazi) : "",
      bafite_umuyoboro_wamashanyarazi:
        household.bafite_umuyoboro_wamashanyarazi || "",
      icyiciro_cy_imibereho: household.icyiciro_cy_imibereho || "",
      umudugudu: household.umudugudu || "",
      akagari: household.akagari || "",
      umurenge: household.umurenge || "",
      akarere: household.akarere || "",
      izina_ry_isibo: household.izina_ry_isibo || "",
      ubwishingizi: household.ubwishingizi || "",
      ubwishingizi_bwihariye: household.ubwishingizi_bwihariye || "",
      telefone_umukuru: household.telefone_umukuru || "",
      indangamuntu_umukuru: household.indangamuntu_umukuru || "",
    });
    // The listing is fetched with `insuranceYear`, so mutuelle_yishyuwe already
    // reflects the selected year.
    setMutuellePaid(!!household.mutuelle_yishyuwe);
    setEditingId(household.urugo_id);
    setFormErrors({});
    setShow(true);
  };

  const openMembersModal = async (household) => {
    const count = Math.max(1, Number(household.umubare_w_abagize) || 1);
    setMembersHousehold(household);
    setMembersLoading(true);
    try {
      const res = await axios.get(`${getApiBase()}/household_members/${household.urugo_id}`);
      const existing = Array.isArray(res.data) ? res.data : [];
      if (existing.length > 0) {
        setSavedMembers(p => ({ ...p, [household.urugo_id]: existing }));
        const names = existing.map(m => m.member_name || '');
        const ids = existing.map(m => m.id);
        while (names.length < count) { names.push(''); ids.push(null); }
        setMemberNames(names.slice(0, count));
        setMemberIds(ids.slice(0, count));
      } else {
        const cached = savedMembers[household.urugo_id] || [];
        const names = cached.length ? cached.map(m => m.member_name || '') : Array(count).fill('');
        const ids = cached.length ? cached.map(m => m.id ?? null) : Array(count).fill(null);
        while (names.length < count) { names.push(''); ids.push(null); }
        setMemberNames(names.slice(0, count));
        setMemberIds(ids.slice(0, count));
      }
    } catch {
      const cached = savedMembers[household.urugo_id] || [];
      const names = cached.length ? cached.map(m => m.member_name || '') : Array(count).fill('');
      const ids = cached.length ? cached.map(m => m.id ?? null) : Array(count).fill(null);
      while (names.length < count) { names.push(''); ids.push(null); }
      setMemberNames(names.slice(0, count));
      setMemberIds(ids.slice(0, count));
    } finally {
      setMembersLoading(false);
    }
    setShowMembers(true);
    setTimeout(() => firstMemberRef.current?.focus(), 150);
  };

  const saveMembers = async () => {
    if (!membersHousehold) return;
    const trimmed = memberNames.map(n => n.trim());
    if (trimmed.some(n => !n)) { showAlertMessage("Uzuza amazina yose y'abagize urugo", 'warning'); return; }
    const uniq = new Set(trimmed.map(n => n.toLowerCase()));
    if (uniq.size !== trimmed.length) { showAlertMessage('Amazina ntashobora kuba amwe mu rugo rumwe', 'warning'); return; }
    setMembersLoading(true);
    try {
      await axios.post(`${getApiBase()}/household_members`, {
        household_id: membersHousehold.urugo_id,
        household_head: membersHousehold.umukuru_w_urugo,
        members: trimmed.map((name, i) => ({ id: memberIds[i] || undefined, member_name: name })),
      });

      // Keep the household's declared member count in sync so re-opening
      // this modal later doesn't truncate the list back down.
      if (trimmed.length !== Number(membersHousehold.umubare_w_abagize)) {
        await axios.put(`${API_URL}/${membersHousehold.urugo_id}`, {
          umukuru_w_urugo: membersHousehold.umukuru_w_urugo || "",
          umubare_w_abagize: trimmed.length,
          aho_batuye: membersHousehold.aho_batuye || "",
          ubwoko_bw_inzu: membersHousehold.ubwoko_bw_inzu || "",
          bafite_amazi: membersHousehold.bafite_amazi || "",
          bafite_umuyoboro_wamashanyarazi: membersHousehold.bafite_umuyoboro_wamashanyarazi || "",
          icyiciro_cy_imibereho: membersHousehold.icyiciro_cy_imibereho || "",
          umudugudu: membersHousehold.umudugudu || "",
          akagari: membersHousehold.akagari || "",
          umurenge: membersHousehold.umurenge || "",
          akarere: membersHousehold.akarere || "",
          izina_ry_isibo: membersHousehold.izina_ry_isibo || "",
          ubwishingizi: membersHousehold.ubwishingizi || "",
          telefone_umukuru: membersHousehold.telefone_umukuru || "",
          indangamuntu_umukuru: membersHousehold.indangamuntu_umukuru || "",
        });
        setMembersHousehold(prev => prev && ({ ...prev, umubare_w_abagize: trimmed.length }));
        fetchData();
      }

      // Re-fetch so memberIds/savedMembers hold the real household_members ids
      // (needed by other features, e.g. Ejo Heza contributions, that key
      // history off a stable member id — not the array index).
      const freshRes = await axios.get(`${getApiBase()}/household_members/${membersHousehold.urugo_id}`);
      const freshRows = Array.isArray(freshRes.data) ? freshRes.data : [];
      setSavedMembers(p => ({ ...p, [membersHousehold.urugo_id]: freshRows }));
      setMemberIds(freshRows.map(m => m.id));
      setMemberNames(freshRows.map(m => m.member_name || ''));
      showAlertMessage('Abagize urugo babitswe neza. ✓', 'success');
      setShowMembers(false);
    } catch (err) {
      showAlertMessage(err.response?.data?.error || 'Ntibyakunze kubika abagize urugo. Ongera ugerageze.', 'danger');
    } finally { setMembersLoading(false); }
  };

  const deleteMembers = async () => {
    if (!membersHousehold) return;
    setMembersLoading(true);
    try {
      await axios.delete(`${getApiBase()}/household_members/${membersHousehold.urugo_id}`);
      setSavedMembers(p => { const n = { ...p }; delete n[membersHousehold.urugo_id]; return n; });
      setMemberNames(Array(memberNames.length).fill(''));
      setMemberIds(Array(memberNames.length).fill(null));
      showAlertMessage('Abagize urugo basibwe neza.', 'success');
    } catch (err) {
      showAlertMessage(err.response?.data?.error || 'Ntibyakunze gusiba abagize urugo. Ongera ugerageze.', 'danger');
    } finally { setMembersLoading(false); }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setLoading(true);
    try {
      await axios.delete(`${API_URL}/${deleteId}`);
      showAlertMessage("🗑️ Urugo rwasibwe burundu!", "success");
      fetchData();
      setShowDeleteModal(false);
    } catch (err) {
      showAlertMessage(
        err.response?.data?.error || "Habaye ikosa mu gusiba urugo",
        "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!form.umukuru_w_urugo.trim())
      errors.umukuru_w_urugo = "Izina ry'umukuru w'urugo ni ngombwa";
    if (!form.umubare_w_abagize || form.umubare_w_abagize < 1)
      errors.umubare_w_abagize = "Umubare ugomba kuba nibura 1";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Mark / unmark a household's Mutuelle as paid for `year`. Isibo-leader only
  // (the server also enforces this); Mudugudu leaders never call it.
  const saveMutuelleStatus = async (urugoId, year, paid) => {
    if (isUmudugudu) return;
    if (paid) {
      await axios.post(`${API_URL}/${urugoId}/mutuelle`, {
        year,
        wanditse_izina: localStorage.getItem("fullname") || "",
      });
    } else {
      await axios.delete(`${API_URL}/${urugoId}/mutuelle/${year}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm())
      return showAlertMessage("Uzuza neza amakuru yose", "warning");

    setLoading(true);
    try {
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, form);
        // Sync the Mutuelle checkbox for the selected year (only meaningful
        // when Mituweli is the chosen scheme).
        if (!isUmudugudu && form.ubwishingizi === "Mituweli") {
          try {
            await saveMutuelleStatus(editingId, insuranceYear, mutuellePaid);
          } catch (mErr) {
            showAlertMessage(
              mErr.response?.data?.error || "Ntibyakunze kuvugurura Mituweli", "warning"
            );
          }
        }
        showAlertMessage("Amakuru y'urugo yavuguruwe neza!", "success");
      } else {
        await axios.post(API_URL, form);
        showAlertMessage("Urugo rwanditswe neza!", "success");
      }
      setShow(false);
      resetForm();
      fetchData();
      if (navigator.vibrate) navigator.vibrate(100);
    } catch (err) {
      showAlertMessage(
        err.response?.data?.error || "Habaye ikosa", "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  // Details modal: quick toggle of the Mutuelle paid status for `insuranceYear`.
  const toggleMutuelleFromDetails = async (household) => {
    const next = !household.mutuelle_yishyuwe;
    try {
      await saveMutuelleStatus(household.urugo_id, insuranceYear, next);
      showAlertMessage(
        next
          ? `Mituweli ${insuranceYear} yashyizweho ko yishyuwe.`
          : `Mituweli ${insuranceYear} yakuweho ku ishyuwe.`,
        "success"
      );
      const updated = {
        ...household,
        mutuelle_yishyuwe: next ? 1 : 0,
        mutuelle_year: insuranceYear,
        mutuelle_itariki: next ? new Date().toISOString() : null,
        mutuelle_wanditse: next ? (localStorage.getItem("fullname") || "") : null,
      };
      setSelectedHousehold(updated);
      fetchData();
    } catch (err) {
      showAlertMessage(
        err.response?.data?.error || "Ntibyakunze guhindura Mituweli", "danger"
      );
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name])
      setFormErrors((prev) => {
        const n = { ...prev };
        delete n[name];
        return n;
      });
  };

  // ────────────────────────────────────────────────
  // Data Fetching & Filtering
  // ────────────────────────────────────────────────
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // ?year= makes the API attach that year's Mutuelle payment status to each row.
      const base = isUmudugudu
        ? `${getApiBase()}/umudugudu/module-data/ingo`
        : API_URL;
      const url = `${base}?year=${insuranceYear}`;
      const res = await axios.get(url);
      const data = Array.isArray(res.data) ? res.data : (res.data?.data ?? res.data?.ingo ?? []);
      setIngoList(data);
      setFilteredData(data);
      calculateStats(data);
    } catch (err) {
      showAlertMessage("Habaye ikosa mu kugira amakuru y'ingo", "danger");
    } finally {
      setLoading(false);
    }
  }, [isUmudugudu, insuranceYear]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let res = [...ingoList];
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      res = res.filter(
        (h) =>
          h.umukuru_w_urugo?.toLowerCase().includes(term) ||
          h.umudugudu?.toLowerCase().includes(term) ||
          h.akagari?.toLowerCase().includes(term) ||
          h.aho_batuye?.toLowerCase().includes(term)
      );
    }
    if (filterUbudehe !== "all")
      res = res.filter((h) => h.icyiciro_cy_imibereho === filterUbudehe);
    if (filterWater !== "all")
      res = res.filter((h) =>
        filterWater === "yego"
          ? isYego(h.bafite_amazi)
          : !isYego(h.bafite_amazi)
      );
    if (filterElectricity !== "all")
      res = res.filter((h) =>
        filterElectricity === "yego"
          ? isYego(h.bafite_umuyoboro_wamashanyarazi)
          : !isYego(h.bafite_umuyoboro_wamashanyarazi)
      );
    if (filterHomeType !== "all")
      res = res.filter((h) => h.ubwoko_bw_inzu === filterHomeType);
    if (filterInsurance !== "all")
      res = res.filter((h) => (h.ubwishingizi || "") === filterInsurance);
    if (filterMutuelle !== "all")
      res = res.filter((h) =>
        filterMutuelle === "yishyuwe" ? !!h.mutuelle_yishyuwe : !h.mutuelle_yishyuwe
      );

    setFilteredData(res);
    setCurrentPage(1);
  }, [
    searchTerm, filterUbudehe, filterWater,
    filterElectricity, filterHomeType, filterInsurance, filterMutuelle, ingoList,
  ]);

  const idxLast = currentPage * itemsPerPage;
  const idxFirst = idxLast - itemsPerPage;
  const current = filteredData.slice(idxFirst, idxLast);
  const totalPg = Math.ceil(filteredData.length / itemsPerPage);

  const paginate = (n) => {
    setCurrentPage(n);
    if (topRef.current && isMobile) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Active filter count
  const activeFilterCount = [
    filterUbudehe !== "all",
    filterWater !== "all",
    filterElectricity !== "all",
    filterHomeType !== "all",
    filterInsurance !== "all",
    filterMutuelle !== "all",
  ].filter(Boolean).length;

  const clearAllFilters = () => {
    setSearchTerm("");
    setFilterUbudehe("all");
    setFilterWater("all");
    setFilterElectricity("all");
    setFilterHomeType("all");
    setFilterInsurance("all");
    setFilterMutuelle("all");
  };

  // ─── Responsive Values ─────────────────────────────────
  const containerPadding = isExtraSmall
    ? "0.5rem"
    : isSmall
    ? "0.65rem"
    : isMobile
    ? "0.85rem"
    : "1rem";

  const headerFontSize = isExtraSmall
    ? "0.95rem"
    : isSmall
    ? "1.1rem"
    : isMobile
    ? "1.25rem"
    : "1.5rem";

  const statValueSize = isExtraSmall
    ? "1.35rem"
    : isSmall
    ? "1.5rem"
    : isMobile
    ? "1.75rem"
    : "2.25rem";

  const statTitleSize = isExtraSmall
    ? "0.6rem"
    : isSmall
    ? "0.65rem"
    : "0.8rem";

  const iconRingSize = isExtraSmall ? 40 : isSmall ? 48 : isMobile ? 56 : 70;
  const iconInnerSize = isExtraSmall ? 30 : isSmall ? 36 : isMobile ? 42 : 54;
  const iconFontSize = isExtraSmall
    ? "0.85rem"
    : isSmall
    ? "1rem"
    : isMobile
    ? "1.15rem"
    : "1.5rem";

  // ────────────────────────────────────────────────
  // Mobile Card Renderer
  // ────────────────────────────────────────────────
  const renderMobileCard = (h, idx) => {
    const ub = ubudeheCategories.find(
      (c) => c.value === h.icyiciro_cy_imibereho
    ) || {};

    return (
      <div
        key={h.urugo_id}
        style={{
          background: `linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%)`,
          border: `1px solid ${theme.border}`,
          borderRadius: isExtraSmall ? "12px" : "16px",
          padding: isExtraSmall ? "0.65rem" : "0.85rem",
          marginBottom: "0.65rem",
          WebkitTapHighlightColor: "transparent",
        }}
      >
        {/* Header Row */}
        <div
          className="d-flex justify-content-between align-items-start"
          style={{ marginBottom: "0.6rem" }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: isExtraSmall ? "0.85rem" : "0.95rem",
                color: theme.textBright,
                marginBottom: "0.2rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <i
                className="bi bi-house-fill me-1"
                style={{ color: theme.primary, fontSize: "0.8rem" }}
              ></i>
              {h.umukuru_w_urugo}
            </div>
            <div className="d-flex gap-1 flex-wrap">
              <Badge
                bg="primary"
                pill
                style={{ fontSize: isExtraSmall ? "0.55rem" : "0.6rem" }}
              >
                <i className="bi bi-people-fill me-1"></i>
                {h.umubare_w_abagize}
              </Badge>
              {h.icyiciro_cy_imibereho && (
                <Badge
                  bg={ub.color || "secondary"}
                  pill
                  style={{ fontSize: isExtraSmall ? "0.55rem" : "0.6rem" }}
                >
                  {h.icyiciro_cy_imibereho}
                </Badge>
              )}
              {h.ubwishingizi && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "3px",
                    fontSize: isExtraSmall ? "0.55rem" : "0.6rem",
                    fontWeight: 600,
                    color: theme.primary,
                    background: theme.primaryLight,
                    border: `1px solid ${theme.border}`,
                    borderRadius: "999px",
                    padding: "1px 7px",
                  }}
                >
                  <i className="bi bi-shield-shaded" />
                  {insuranceLabel(h)}
                </span>
              )}
              {mutuelleBadge(h) && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "3px",
                    fontSize: isExtraSmall ? "0.55rem" : "0.6rem",
                    fontWeight: 700,
                    color: "#fff",
                    background: mutuelleBadge(h).paid ? theme.success : theme.danger,
                    borderRadius: "999px",
                    padding: "1px 7px",
                  }}
                >
                  <i className={`bi bi-${mutuelleBadge(h).paid ? "check-circle-fill" : "x-circle-fill"}`} />
                  Mutuelle {insuranceYear}
                </span>
              )}
            </div>
          </div>
          <span
            style={{
              color: theme.textMuted,
              fontSize: "0.7rem",
              flexShrink: 0,
              marginLeft: "0.5rem",
            }}
          >
            #{idxFirst + idx + 1}
          </span>
        </div>

        {/* Info Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: isExtraSmall ? "0.3rem" : "0.4rem",
            marginBottom: "0.6rem",
          }}
        >
          {/* Water */}
          <div
            style={{
              background: theme.bgSecondary,
              borderRadius: "10px",
              padding: "0.5rem",
              border: `1px solid ${theme.border}`,
            }}
          >
            <div
              style={{
                fontSize: "0.55rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.3px",
                marginBottom: "0.2rem",
              }}
            >
              Amazi
            </div>
            <Badge
              bg={getYegoOyaColor(h.bafite_amazi)}
              pill
              style={{ fontSize: "0.6rem" }}
            >
              <i className={`bi bi-${getYegoOyaIcon(h.bafite_amazi)} me-1`}></i>
              {getYegoOyaText(h.bafite_amazi)}
            </Badge>
          </div>

          {/* Electricity */}
          <div
            style={{
              background: theme.bgSecondary,
              borderRadius: "10px",
              padding: "0.5rem",
              border: `1px solid ${theme.border}`,
            }}
          >
            <div
              style={{
                fontSize: "0.55rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.3px",
                marginBottom: "0.2rem",
              }}
            >
              Amashanyarazi
            </div>
            <Badge
              bg={getYegoOyaColor(h.bafite_umuyoboro_wamashanyarazi)}
              pill
              style={{ fontSize: "0.6rem" }}
            >
              <i
                className={`bi bi-${getYegoOyaIcon(
                  h.bafite_umuyoboro_wamashanyarazi
                )} me-1`}
              ></i>
              {getYegoOyaText(h.bafite_umuyoboro_wamashanyarazi)}
            </Badge>
          </div>

          {/* Location */}
          <div
            style={{
              background: theme.bgSecondary,
              borderRadius: "10px",
              padding: "0.5rem",
              border: `1px solid ${theme.border}`,
            }}
          >
            <div
              style={{
                fontSize: "0.55rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.3px",
                marginBottom: "0.2rem",
              }}
            >
              Umudugudu
            </div>
            <div
              style={{
                fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
                color: theme.text,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {h.umudugudu || "—"}
            </div>
          </div>

          {/* House Type */}
          <div
            style={{
              background: theme.bgSecondary,
              borderRadius: "10px",
              padding: "0.5rem",
              border: `1px solid ${theme.border}`,
            }}
          >
            <div
              style={{
                fontSize: "0.55rem",
                color: theme.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.3px",
                marginBottom: "0.2rem",
              }}
            >
              Ubwoko bw'Inzu
            </div>
            <div
              style={{
                fontSize: isExtraSmall ? "0.7rem" : "0.75rem",
                color: theme.text,
              }}
            >
              {h.ubwoko_bw_inzu || "—"}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div
          className="d-flex gap-2"
          style={{
            borderTop: `1px solid ${theme.border}`,
            paddingTop: "0.6rem",
          }}
        >
          <Button
            variant="outline-info"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.65rem" : "0.7rem",
              minHeight: "36px",
              borderColor: theme.info,
              color: theme.info,
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
            onClick={() => handleViewDetails(h)}
          >
            <i className="bi bi-eye me-1"></i>
            {!isExtraSmall && "Reba"}
          </Button>
          <Button
            variant="outline-light"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.65rem" : "0.7rem",
              minHeight: "36px",
              borderColor: savedMembers[h.urugo_id]?.length > 0 ? theme.success : theme.primary,
              color: savedMembers[h.urugo_id]?.length > 0 ? theme.success : theme.primary,
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
            onClick={() => openMembersModal(h)}
          >
            <i className="bi bi-people me-1"></i>
            {!isExtraSmall && (savedMembers[h.urugo_id]?.length > 0 ? '✓' : 'Abagize')}
          </Button>
          <Button
            variant="outline-primary"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.65rem" : "0.7rem",
              minHeight: "36px",
              borderColor: theme.primary,
              color: theme.primary,
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
            onClick={() => handleEdit(h)}
          >
            <i className="bi bi-pencil me-1"></i>
            {!isExtraSmall && "Hindura"}
          </Button>
          <Button
            variant="outline-danger"
            size="sm"
            className="flex-fill"
            style={{
              borderRadius: "10px",
              fontSize: isExtraSmall ? "0.65rem" : "0.7rem",
              minHeight: "36px",
              borderColor: theme.danger,
              color: theme.danger,
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
            onClick={() => openDeleteModal(h.urugo_id)}
          >
            <i className="bi bi-trash me-1"></i>
            {!isExtraSmall && "Siba"}
          </Button>
        </div>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // Responsive Pagination
  // ────────────────────────────────────────────────
  const renderPagination = () => {
    if (totalPg <= 1) return null;

    const maxVisible = isExtraSmall ? 3 : isSmall ? 3 : isMobile ? 5 : 7;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPg, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) pages.push(i);

    return (
      <div
        className="d-flex justify-content-between align-items-center flex-wrap"
        style={{ marginTop: "0.75rem", gap: "0.5rem" }}
      >
        <small
          style={{
            color: theme.textMuted,
            fontSize: isSmall ? "0.65rem" : "0.75rem",
          }}
        >
          {idxFirst + 1} – {Math.min(idxLast, filteredData.length)} kuri{" "}
          {filteredData.length}
        </small>
        <Pagination className="mb-0" size={isSmall ? "sm" : undefined}>
          <Pagination.Prev
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {startPage > 1 && (
            <>
              <Pagination.Item onClick={() => paginate(1)}>1</Pagination.Item>
              {startPage > 2 && <Pagination.Ellipsis disabled />}
            </>
          )}
          {pages.map((p) => (
            <Pagination.Item
              key={p}
              active={p === currentPage}
              onClick={() => paginate(p)}
            >
              {p}
            </Pagination.Item>
          ))}
          {endPage < totalPg && (
            <>
              {endPage < totalPg - 1 && <Pagination.Ellipsis disabled />}
              <Pagination.Item onClick={() => paginate(totalPg)}>
                {totalPg}
              </Pagination.Item>
            </>
          )}
          <Pagination.Next
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPg}
          />
        </Pagination>
      </div>
    );
  };

  // ────────────────────────────────────────────────
  // JSX
  // ────────────────────────────────────────────────
  return (
    <div
      ref={topRef}
      style={{
        background: theme.bg,
        color: theme.text,
        minHeight: "100vh",
        padding: containerPadding,
        paddingTop: isMobile
          ? `max(${containerPadding}, env(safe-area-inset-top, 0px))`
          : containerPadding,
        paddingBottom: isMobile
          ? `max(${containerPadding}, env(safe-area-inset-bottom, 0px))`
          : containerPadding,
        WebkitOverflowScrolling: "touch",
        overflowX: "hidden",
      }}
    >
      {/* ═══════════ RESPONSIVE GLOBAL STYLES ═══════════ */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800&display=swap');

        * {
          font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
            Roboto, 'Helvetica Neue', Arial, sans-serif;
          -webkit-text-size-adjust: 100%;
          text-size-adjust: 100%;
          box-sizing: border-box;
        }

        html, body {  }

        /* ─── Stat Cards ─── */
        .stat-card {
          background: linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%) !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isSmall ? "14px" : "20px"} !important;
          transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1) !important;
          box-shadow: 0 1px 4px rgba(30,58,95,0.06) !important;
          overflow: hidden;
        }

        @media (hover: hover) and (min-width: 769px) {
          .stat-card:hover {
            transform: translateY(-6px) scale(1.02) !important;
            box-shadow: 0 20px 40px -12px rgba(30, 58, 95, 0.2) !important;
            border-color: ${theme.primary} !important;
          }
        }

        @media (hover: none) {
          .stat-card:active {
            transform: scale(0.98) !important;
            border-color: ${theme.primary} !important;
          }
          .stat-card:hover { transform: none !important; }
        }

        /* ─── Icon Ring ─── */
        .icon-ring {
          width: ${iconRingSize}px;
          height: ${iconRingSize}px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin: 0 auto;
        }
        .icon-ring::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          padding: ${isSmall ? "2px" : "3px"};
          background: linear-gradient(135deg, var(--ring-color) 0%, transparent 60%);
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
        }
        .icon-ring-inner {
          width: ${iconInnerSize}px;
          height: ${iconInnerSize}px;
          border-radius: 50%;
          background: linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* ─── Table ─── */
        .modern-table-wrapper {
          background: ${theme.card};
          border: 1px solid ${theme.border};
          border-radius: ${isSmall ? "12px" : "20px"};
          overflow: hidden;
          box-shadow: 0 12px 32px -12px rgba(30, 58, 95, 0.15);
        }
        .modern-table {
          background-color: ${theme.card} !important;
          color: ${theme.text} !important;
          margin-bottom: 0 !important;
        }
        .modern-table thead {
          background: linear-gradient(180deg, ${theme.primary} 0%, #142943 100%) !important;
        }
        .modern-table thead th {
          background: transparent !important;
          color: rgba(255,255,255,0.85) !important;
          font-weight: 600 !important;
          font-size: ${isTablet ? "0.65rem" : "0.7rem"} !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
          padding: ${isTablet ? "0.75rem 0.5rem" : "1rem 0.75rem"} !important;
          border-bottom: 1px solid rgba(255,255,255,0.12) !important;
          white-space: nowrap;
        }
        .modern-table tbody tr {
          transition: all 0.3s ease !important;
          border-bottom: 1px solid ${theme.border} !important;
        }
        @media (hover: hover) {
          .modern-table tbody tr:hover {
            background: ${theme.bgSecondary} !important;
          }
        }
        .modern-table tbody td {
          background: transparent !important;
          color: ${theme.text} !important;
          padding: ${isTablet ? "0.75rem 0.5rem" : "1rem 0.75rem"} !important;
          vertical-align: middle !important;
          border: none !important;
          font-size: ${isTablet ? "0.78rem" : "0.85rem"} !important;
        }
        .modern-table tbody tr:last-child {
          border-bottom: none !important;
        }

        /* ─── Table scroll ─── */
        .table-scroll-wrapper {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-x: contain;
        }
        .table-scroll-wrapper::-webkit-scrollbar {
          height: ${isMobile ? "0" : "6px"};
        }
        .table-scroll-wrapper::-webkit-scrollbar-track { background: transparent; }
        .table-scroll-wrapper::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 10px;
        }

        /* ─── Buttons ─── */
        .btn-action {
          width: ${isSmall ? "32px" : "36px"} !important;
          height: ${isSmall ? "32px" : "36px"} !important;
          padding: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          border-radius: 10px !important;
          transition: all 0.3s ease !important;
          border: 1px solid transparent !important;
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        @media (hover: hover) {
          .btn-action:hover { transform: scale(1.1) !important; }
        }
        .btn-action.btn-outline-info { border-color: ${theme.info} !important; color: ${theme.info} !important; }
        .btn-action.btn-outline-info:hover { background: rgba(29,78,216,0.1) !important; }
        .btn-action.btn-outline-primary { border-color: ${theme.primary} !important; color: ${theme.primary} !important; }
        .btn-action.btn-outline-primary:hover { background: rgba(30,58,95,0.1) !important; }
        .btn-action.btn-outline-danger { border-color: ${theme.danger} !important; color: ${theme.danger} !important; }
        .btn-action.btn-outline-danger:hover { background: rgba(220,38,38,0.1) !important; }

        .btn-primary-modern {
          background: linear-gradient(135deg, ${theme.primary} 0%, #142943 100%) !important;
          border: none !important;
          border-radius: ${isSmall ? "10px" : "14px"} !important;
          padding: ${isSmall ? "0.6rem 0.85rem" : "0.85rem 1.5rem"} !important;
          font-weight: 600 !important;
          font-size: ${isSmall ? "0.78rem" : "0.88rem"} !important;
          transition: all 0.3s ease !important;
          box-shadow: 0 4px 15px rgba(30,58,95,0.25) !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        @media (hover: hover) {
          .btn-primary-modern:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 8px 22px rgba(30,58,95,0.32) !important;
          }
        }

        /* ─── Filter Card ─── */
        .filter-card {
          background: linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%) !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isSmall ? "12px" : "16px"} !important;
        }

        /* ─── Search Input ─── */
        .search-input {
          background: ${theme.card} !important;
          border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important;
          border-radius: 12px !important;
          transition: all 0.3s ease !important;
          font-size: 16px !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-appearance: none;
          appearance: none;
        }
        .search-input:focus {
          border-color: ${theme.primary} !important;
          box-shadow: 0 0 0 3px rgba(30,58,95,0.15) !important;
        }
        .search-input::placeholder { color: #94a3b8 !important; }

        /* ─── Filter Select ─── */
        .filter-select {
          background: ${theme.card} !important;
          border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important;
          border-radius: 12px !important;
          padding: ${isSmall ? "0.5rem 0.6rem" : "0.6rem 1rem"} !important;
          font-size: 16px !important;
          cursor: pointer !important;
          transition: all 0.3s ease !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-appearance: none;
          appearance: none;
        }
        .filter-select:focus {
          border-color: ${theme.primary} !important;
          box-shadow: 0 0 0 3px rgba(30,58,95,0.15) !important;
        }
        .filter-select option { background: ${theme.card}; color: ${theme.text}; }

        /* ─── Pagination ─── */
        .pagination .page-link {
          background: ${theme.card} !important;
          border-color: ${theme.border} !important;
          color: ${theme.textMuted} !important;
          border-radius: ${isSmall ? "8px" : "10px"} !important;
          margin: 0 ${isSmall ? "1px" : "3px"} !important;
          transition: all 0.3s ease !important;
          min-width: ${isMobile ? "36px" : "40px"};
          height: ${isMobile ? "36px" : "40px"};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: ${isSmall ? "0.7rem" : "0.8rem"};
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        .pagination .page-link:hover {
          background: ${theme.bgSecondary} !important;
          border-color: ${theme.primary} !important;
          color: ${theme.primary} !important;
        }
        .pagination .page-item.active .page-link {
          background: linear-gradient(135deg, ${theme.primary} 0%, #142943 100%) !important;
          border-color: ${theme.primary} !important;
          color: #fff !important;
        }

        /* ─── Modal ─── */
        .modal-content {
          background: ${theme.card} !important;
          border: 1px solid ${theme.border} !important;
          border-radius: ${isMobile ? "16px" : "24px"} !important;
          color: ${theme.text} !important;
          margin: ${isMobile ? "0.5rem" : "auto"};
          max-height: ${isMobile ? "92vh" : "auto"};
        }
        .modal-header {
          border-bottom: 1px solid ${theme.border} !important;
          padding: ${isSmall ? "0.75rem 1rem" : "1.25rem 1.5rem"} !important;
        }
        .modal-body {
          padding: ${isSmall ? "0.75rem" : isMobile ? "1rem" : "1.5rem"} !important;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          max-height: ${isMobile ? "65vh" : "auto"};
        }
        .modal-footer {
          border-top: 1px solid ${theme.border} !important;
          padding: ${isSmall ? "0.5rem 0.75rem" : "1rem 1.5rem"} !important;
          flex-wrap: wrap;
          gap: 0.5rem;
        }
        .modal-title {
          font-size: ${isSmall ? "0.9rem" : isMobile ? "1rem" : "1.2rem"} !important;
        }

        /* ─── Form Controls ─── */
        .form-control, .form-select {
          background: ${theme.card} !important;
          border: 1px solid ${theme.border} !important;
          color: ${theme.text} !important;
          border-radius: 12px !important;
          padding: ${isSmall ? "0.6rem 0.75rem" : "0.75rem 1rem"} !important;
          font-size: 16px !important;
          min-height: ${isMobile ? "44px" : "auto"};
          -webkit-appearance: none;
          appearance: none;
        }
        .form-control:focus, .form-select:focus {
          border-color: ${theme.primary} !important;
          box-shadow: 0 0 0 3px rgba(30,58,95,0.15) !important;
          background: ${theme.card} !important;
          color: ${theme.text} !important;
        }
        .form-label {
          color: ${theme.textMuted} !important;
          font-weight: 500 !important;
          margin-bottom: 0.4rem !important;
          font-size: ${isSmall ? "0.78rem" : "0.85rem"} !important;
        }

        /* ─── Badge ─── */
        .badge {
          font-weight: 500 !important;
          padding: ${isSmall ? "0.35rem 0.55rem" : "0.5rem 0.75rem"} !important;
          font-size: ${isSmall ? "0.6rem" : "0.7rem"} !important;
          border-radius: 8px !important;
        }

        /* ─── Alert ─── */
        .alert {
          border-radius: ${isSmall ? "10px" : "14px"} !important;
          border: none !important;
          font-size: ${isSmall ? "0.78rem" : "0.88rem"} !important;
        }

        /* ─── Empty State ─── */
        .empty-state {
          background: linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%);
          border: 1px dashed ${theme.border};
          border-radius: ${isSmall ? "14px" : "20px"};
        }

        /* ─── Mobile Filter Panel ─── */
        .mobile-filter-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.6);
          z-index: 1055;
          opacity: ${showMobileFilters ? 1 : 0};
          pointer-events: ${showMobileFilters ? "auto" : "none"};
          transition: opacity 0.3s ease;
        }
        .mobile-filter-panel {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: ${theme.card};
          border-top: 1px solid ${theme.border};
          border-radius: 20px 20px 0 0;
          padding: 1.25rem;
          padding-bottom: max(1.25rem, env(safe-area-inset-bottom, 0px));
          z-index: 1060;
          transform: translateY(${showMobileFilters ? "0" : "100%"});
          transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          box-shadow: 0 -10px 40px rgba(0,0,0,0.5);
          max-height: 75vh;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }

        /* ─── Safe Areas ─── */
        @supports (padding: max(0px)) {
          .safe-pad {
            padding-left: max(0px, env(safe-area-inset-left));
            padding-right: max(0px, env(safe-area-inset-right));
          }
        }

        /* ─── Touch Active States ─── */
        @media (hover: none) {
          button:active, .btn:active {
            opacity: 0.8 !important;
            transform: scale(0.97) !important;
          }
          .card:hover { transform: none !important; box-shadow: none !important; }
        }

        /* ─── Galaxy Fold ─── */
        @media (max-width: 280px) {
          .card-body { padding: 0.35rem !important; }
          .btn { font-size: 0.65rem !important; padding: 0.2rem 0.35rem !important; }
          .badge { font-size: 0.5rem !important; padding: 0.2rem 0.35rem !important; }
        }

        /* ─── Landscape Short Screen ─── */
        @media (max-height: 500px) and (orientation: landscape) {
          .icon-ring { display: none !important; }
          .stat-card .card-body { padding: 0.4rem !important; }
        }

        /* ─── Reduced Motion ─── */
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            transition-duration: 0.01ms !important;
          }
        }

        /* ─── Print ─── */
        @media print {
          body { background: white !important; color: black !important; }
          .btn, .filter-card, .stat-card, .mobile-filter-panel,
          .mobile-filter-overlay { display: none !important; }
          .modern-table, .modern-table th, .modern-table td {
            color: black !important;
            background: white !important;
            border: 1px solid #ccc !important;
          }
        }

        /* ─── Scrollbar ─── */
        ::-webkit-scrollbar { width: ${isMobile ? "0" : "6px"}; height: ${isMobile ? "0" : "6px"}; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* ─── Touch targets ─── */
        @media (pointer: coarse) {
          button, .btn, a, select, input { min-height: 44px; }
        }
      `}</style>

      {/* ═══════════ HEADER ═══════════ */}
      <div
        className="d-flex justify-content-between align-items-start flex-wrap"
        style={{ marginBottom: isMobile ? "0.75rem" : "1.25rem", gap: "0.5rem" }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2
            className="fw-bold mb-1"
            style={{
              color: theme.primary,
              fontSize: headerFontSize,
              lineHeight: 1.3,
            }}
          >
            <i className="bi bi-house-door-fill me-2"></i>
            {isExtraSmall ? "Ingo" : "Ingo"}
          </h2>
          {!isShortScreen && (
            <small
              style={{
                color: theme.textMuted,
                fontSize: isSmall ? "0.65rem" : "0.78rem",
                display: "block",
              }}
            >
              {isSmall
                ? "Gucunga ingo"
                : "Gucunga no gukurikirana ingo z'umudugudu"}
            </small>
          )}
        </div>

        <div className="d-flex gap-2 flex-shrink-0">
          <Button
            className="btn-primary-modern"
            onClick={() => {
              resetForm();
              setShow(true);
            }}
          >
            <i className="bi bi-house-add me-1"></i>
            {isExtraSmall ? "+" : isSmall ? "Andika" : "Andika Urugo"}
          </Button>
          <Button
            variant="outline-light"
            onClick={fetchData}
            style={{
              borderRadius: "12px",
              borderColor: theme.border,
              minWidth: isMobile ? "40px" : "auto",
              minHeight: isMobile ? "40px" : "auto",
              padding: isSmall ? "0.35rem" : "0.5rem 0.75rem",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
          >
            <i className="bi bi-arrow-clockwise"></i>
          </Button>
          <Button
            variant="outline-success"
            onClick={exportToCSV}
            style={{
              borderRadius: "12px",
              minWidth: isMobile ? "40px" : "auto",
              minHeight: isMobile ? "40px" : "auto",
              padding: isSmall ? "0.35rem" : "0.5rem 0.75rem",
              fontSize: isSmall ? "0.7rem" : "0.82rem",
              WebkitTapHighlightColor: "transparent",
              touchAction: "manipulation",
            }}
          >
            <i className="bi bi-download"></i>
            {!isSmall && <span className="ms-1">Excel</span>}
          </Button>
        </div>
      </div>

      {/* ═══════════ ALERT ═══════════ */}
      {alert.show && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({ show: false })}
          className="mb-3 shadow"
          style={{
            position: isMobile ? "fixed" : "relative",
            top: isMobile ? "max(0.5rem, env(safe-area-inset-top, 0px))" : "auto",
            left: isMobile ? "0.5rem" : "auto",
            right: isMobile ? "0.5rem" : "auto",
            zIndex: isMobile ? 1100 : "auto",
            margin: isMobile ? 0 : undefined,
          }}
        >
          {alert.message}
        </Alert>
      )}

      {/* ═══════════ STATS ═══════════ */}
      <Row
        className="mb-3"
        style={{ rowGap: isSmall ? "0.4rem" : "0.75rem" }}
      >
        {[
          {
            title: isSmall ? "Ingo" : "Ingo Zose",
            val: stats.total,
            color: theme.primary,
            icon: "houses-fill",
            sub: `${stats.totalMembers} abaturage`,
          },
          {
            title: "Amazi",
            val: stats.withWater,
            color: theme.info,
            icon: "droplet-fill",
            percent: stats.total
              ? Math.round((stats.withWater / stats.total) * 100)
              : 0,
          },
          {
            title: isSmall ? "Mashanyarazi" : "Amashanyarazi",
            val: stats.withElectricity,
            color: theme.warning,
            icon: "lightning-charge-fill",
            percent: stats.total
              ? Math.round((stats.withElectricity / stats.total) * 100)
              : 0,
          },
          {
            title: isSmall ? "Ikigero" : "Ikigereranyo",
            val: stats.avgMembersPerHouse,
            color: theme.success,
            icon: "people-fill",
            sub: isSmall ? "/urugo" : "abaturage / urugo",
          },
        ].map((s, i) => (
          <Col key={i} xs={6} lg={3} className="mb-1 mb-lg-0">
            <Card className="stat-card border-0 h-100">
              <Card.Body
                className="text-center"
                style={{
                  padding: isExtraSmall
                    ? "0.5rem"
                    : isSmall
                    ? "0.65rem"
                    : "1rem",
                }}
              >
                {!(isShortScreen && isLandscape) && (
                  <div
                    className="icon-ring mb-2"
                    style={{ "--ring-color": s.color }}
                  >
                    <div className="icon-ring-inner">
                      <i
                        className={`bi bi-${s.icon}`}
                        style={{
                          fontSize: iconFontSize,
                          color: s.color,
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    fontSize: statValueSize,
                    fontWeight: 800,
                    color: theme.textBright,
                    lineHeight: 1.2,
                  }}
                >
                  {typeof s.val === "number"
                    ? s.val.toLocaleString()
                    : s.val}
                </div>
                <div
                  style={{
                    fontSize: statTitleSize,
                    fontWeight: 600,
                    color: theme.textMuted,
                    textTransform: "uppercase",
                    letterSpacing: "0.3px",
                    marginTop: "0.15rem",
                  }}
                >
                  {s.title}
                </div>
                {s.sub && !isExtraSmall && (
                  <div
                    style={{
                      fontSize: "0.65rem",
                      color: theme.textMuted,
                      marginTop: "0.1rem",
                    }}
                  >
                    {s.sub}
                  </div>
                )}
                {s.percent !== undefined && (
                  <Badge
                    className="mt-1"
                    style={{
                      background: `${s.color}20`,
                      color: s.color,
                      fontSize: isSmall ? "0.6rem" : "0.7rem",
                    }}
                  >
                    {s.percent}%
                  </Badge>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* ═══════════ FILTERS ═══════════ */}
      <Card className="filter-card border-0 shadow mb-3">
        <Card.Body
          style={{
            padding: isSmall ? "0.6rem" : isMobile ? "0.75rem" : "1rem",
          }}
        >
          {isMobile ? (
            /* ── MOBILE FILTER LAYOUT ── */
            <div>
              <div className="d-flex gap-2">
                <InputGroup style={{ flex: 1 }}>
                  <InputGroup.Text
                    style={{
                      background: theme.bgSecondary,
                      borderColor: theme.border,
                      color: theme.textMuted,
                      borderRadius: "12px 0 0 12px",
                      padding: "0.4rem",
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Shakisha..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                    style={{ borderRadius: "0 12px 12px 0" }}
                  />
                </InputGroup>
                <Button
                  variant="outline-light"
                  onClick={() => setShowMobileFilters(true)}
                  style={{
                    borderRadius: "12px",
                    borderColor:
                      activeFilterCount > 0 ? theme.primary : theme.border,
                    color:
                      activeFilterCount > 0 ? theme.primary : theme.textMuted,
                    minWidth: "44px",
                    minHeight: "44px",
                    position: "relative",
                    WebkitTapHighlightColor: "transparent",
                    touchAction: "manipulation",
                  }}
                >
                  <i className="bi bi-sliders"></i>
                  {activeFilterCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-4px",
                        right: "-4px",
                        background: theme.danger,
                        color: "#fff",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        fontSize: "0.6rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 700,
                      }}
                    >
                      {activeFilterCount}
                    </span>
                  )}
                </Button>
                {!isExtraSmall && (
                  <Button
                    variant="outline-light"
                    onClick={() => setUseCardView(!useCardView)}
                    style={{
                      borderRadius: "12px",
                      borderColor: theme.border,
                      minWidth: "44px",
                      minHeight: "44px",
                      WebkitTapHighlightColor: "transparent",
                      touchAction: "manipulation",
                    }}
                  >
                    <i
                      className={`bi bi-${
                        useCardView ? "table" : "grid-3x3-gap"
                      }`}
                    ></i>
                  </Button>
                )}
              </div>

              {/* Active filter chips */}
              {activeFilterCount > 0 && (
                <div className="d-flex gap-1 flex-wrap mt-2">
                  {filterUbudehe !== "all" && (
                    <Badge
                      bg="warning"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.6rem" }}
                      onClick={() => setFilterUbudehe("all")}
                    >
                      {filterUbudehe} ✕
                    </Badge>
                  )}
                  {filterWater !== "all" && (
                    <Badge
                      bg="info"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.6rem" }}
                      onClick={() => setFilterWater("all")}
                    >
                      Amazi: {filterWater} ✕
                    </Badge>
                  )}
                  {filterElectricity !== "all" && (
                    <Badge
                      bg="warning"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.6rem" }}
                      onClick={() => setFilterElectricity("all")}
                    >
                      Mashanyarazi: {filterElectricity} ✕
                    </Badge>
                  )}
                  {filterHomeType !== "all" && (
                    <Badge
                      bg="primary"
                      pill
                      style={{ cursor: "pointer", fontSize: "0.6rem" }}
                      onClick={() => setFilterHomeType("all")}
                    >
                      {filterHomeType} ✕
                    </Badge>
                  )}
                  <Badge
                    bg="secondary"
                    pill
                    style={{ cursor: "pointer", fontSize: "0.6rem" }}
                    onClick={clearAllFilters}
                  >
                    Siba byose ✕
                  </Badge>
                </div>
              )}
            </div>
          ) : (
            /* ── DESKTOP FILTER LAYOUT ── */
            <Row className="g-2 g-md-3">
              <Col md={4}>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      background: theme.bgSecondary,
                      borderColor: theme.border,
                      color: theme.textMuted,
                      borderRadius: "12px 0 0 12px",
                    }}
                  >
                    <i className="bi bi-search"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Shakisha amazina, umudugudu, akagari..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                    style={{ borderRadius: "0 12px 12px 0" }}
                  />
                </InputGroup>
              </Col>
              <Col md={8}>
                <div className="d-flex gap-2 flex-wrap">
                  <Form.Select
                    value={filterUbudehe}
                    onChange={(e) => setFilterUbudehe(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "110px" }}
                  >
                    <option value="all">Ubudehe</option>
                    {ubudeheCategories.map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Select
                    value={filterWater}
                    onChange={(e) => setFilterWater(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "90px" }}
                  >
                    <option value="all">Amazi</option>
                    <option value="yego">Yego</option>
                    <option value="oya">Oya</option>
                  </Form.Select>
                  <Form.Select
                    value={filterElectricity}
                    onChange={(e) => setFilterElectricity(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "120px" }}
                  >
                    <option value="all">Amashanyarazi</option>
                    <option value="yego">Yego</option>
                    <option value="oya">Oya</option>
                  </Form.Select>
                  <Form.Select
                    value={filterHomeType}
                    onChange={(e) => setFilterHomeType(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "100px" }}
                  >
                    <option value="all">Inzu</option>
                    <option value="Iyabo">Iyabo</option>
                    <option value="Ikodeshejwe">Ikodeshejwe</option>
                  </Form.Select>
                  <Form.Select
                    value={filterInsurance}
                    onChange={(e) => setFilterInsurance(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "120px" }}
                  >
                    <option value="all">Ubwishingizi</option>
                    {INSURANCE_TYPES.map((t) => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </Form.Select>
                  <Form.Select
                    value={filterMutuelle}
                    onChange={(e) => setFilterMutuelle(e.target.value)}
                    className="filter-select"
                    style={{ flex: 1, minWidth: "130px" }}
                  >
                    <option value="all">Mutuelle (byose)</option>
                    <option value="yishyuwe">Yishyuwe</option>
                    <option value="oya">Ntabwo yishyuwe</option>
                  </Form.Select>
                  <Form.Select
                    value={insuranceYear}
                    onChange={(e) => setInsuranceYear(Number(e.target.value))}
                    className="filter-select"
                    title="Umwaka wa Mutuelle"
                    style={{ flex: 1, minWidth: "90px" }}
                  >
                    {insuranceYearOptions.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </Form.Select>
                  {activeFilterCount > 0 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={clearAllFilters}
                      style={{ borderRadius: "10px", whiteSpace: "nowrap" }}
                    >
                      <i className="bi bi-x-lg me-1"></i>Siba
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>

      {/* ═══════════ MOBILE FILTER PANEL ═══════════ */}
      {isMobile && (
        <>
          <div
            className="mobile-filter-overlay"
            onClick={() => setShowMobileFilters(false)}
          />
          <div className="mobile-filter-panel">
            <div
              style={{
                width: "36px",
                height: "4px",
                background: "#cbd5e1",
                borderRadius: "2px",
                margin: "0 auto 1rem",
              }}
            />
            <h6
              style={{
                color: theme.textBright,
                fontWeight: 700,
                marginBottom: "1rem",
                fontSize: "0.95rem",
              }}
            >
              <i className="bi bi-sliders me-2"></i>Amahitamo
            </h6>

            {/* Ubudehe */}
            <div style={{ marginBottom: "0.85rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  marginBottom: "0.4rem",
                  display: "block",
                }}
              >
                Ubudehe
              </label>
              <div className="d-flex gap-2 flex-wrap">
                {[{ val: "all", label: "Byose" }, ...ubudeheCategories.map((c) => ({ val: c.value, label: c.label }))].map(
                  (opt) => (
                    <Button
                      key={opt.val}
                      variant={
                        filterUbudehe === opt.val ? "primary" : "outline-light"
                      }
                      size="sm"
                      onClick={() => setFilterUbudehe(opt.val)}
                      style={{
                        borderRadius: "10px",
                        minHeight: "38px",
                        borderColor:
                          filterUbudehe === opt.val
                            ? theme.primary
                            : theme.border,
                        WebkitTapHighlightColor: "transparent",
                        fontSize: "0.78rem",
                      }}
                    >
                      {opt.label}
                    </Button>
                  )
                )}
              </div>
            </div>

            {/* Water */}
            <div style={{ marginBottom: "0.85rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  marginBottom: "0.4rem",
                  display: "block",
                }}
              >
                Amazi
              </label>
              <div className="d-flex gap-2">
                {[
                  { val: "all", label: "Byose" },
                  { val: "yego", label: "Yego" },
                  { val: "oya", label: "Oya" },
                ].map((opt) => (
                  <Button
                    key={opt.val}
                    variant={
                      filterWater === opt.val ? "info" : "outline-light"
                    }
                    size="sm"
                    onClick={() => setFilterWater(opt.val)}
                    style={{
                      borderRadius: "10px",
                      flex: 1,
                      minHeight: "38px",
                      borderColor:
                        filterWater === opt.val ? theme.info : theme.border,
                      WebkitTapHighlightColor: "transparent",
                      fontSize: "0.78rem",
                    }}
                  >
                    {opt.label}
                  </Button>
                ))}
              </div>
            </div>

            {/* Electricity */}
            <div style={{ marginBottom: "0.85rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  marginBottom: "0.4rem",
                  display: "block",
                }}
              >
                Amashanyarazi
              </label>
              <div className="d-flex gap-2">
                {[
                  { val: "all", label: "Byose" },
                  { val: "yego", label: "Yego" },
                  { val: "oya", label: "Oya" },
                ].map((opt) => (
                  <Button
                    key={opt.val}
                    variant={
                      filterElectricity === opt.val
                        ? "warning"
                        : "outline-light"
                    }
                    size="sm"
                    onClick={() => setFilterElectricity(opt.val)}
                    style={{
                      borderRadius: "10px",
                      flex: 1,
                      minHeight: "38px",
                      borderColor:
                        filterElectricity === opt.val
                          ? theme.warning
                          : theme.border,
                      WebkitTapHighlightColor: "transparent",
                      fontSize: "0.78rem",
                    }}
                  >
                    {opt.label}
                  </Button>
                ))}
              </div>
            </div>

            {/* Home Type */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  marginBottom: "0.4rem",
                  display: "block",
                }}
              >
                Ubwoko bw'Inzu
              </label>
              <div className="d-flex gap-2">
                {[
                  { val: "all", label: "Byose" },
                  { val: "Iyabo", label: "Iyabo" },
                  { val: "Ikodeshejwe", label: "Ikodeshejwe" },
                ].map((opt) => (
                  <Button
                    key={opt.val}
                    variant={
                      filterHomeType === opt.val ? "primary" : "outline-light"
                    }
                    size="sm"
                    onClick={() => setFilterHomeType(opt.val)}
                    style={{
                      borderRadius: "10px",
                      flex: 1,
                      minHeight: "38px",
                      borderColor:
                        filterHomeType === opt.val
                          ? theme.primary
                          : theme.border,
                      WebkitTapHighlightColor: "transparent",
                      fontSize: "0.78rem",
                    }}
                  >
                    {opt.label}
                  </Button>
                ))}
              </div>
            </div>

            {/* Insurance + Mutuelle + Year */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label
                style={{
                  color: theme.textMuted,
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  marginBottom: "0.4rem",
                  display: "block",
                }}
              >
                Ubwishingizi &amp; Mutuelle
              </label>
              <div className="d-flex flex-column gap-2">
                <Form.Select
                  value={filterInsurance}
                  onChange={(e) => setFilterInsurance(e.target.value)}
                  size="sm"
                  style={{ borderRadius: "10px" }}
                >
                  <option value="all">Ubwishingizi bwose</option>
                  {INSURANCE_TYPES.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </Form.Select>
                <div className="d-flex gap-2">
                  <Form.Select
                    value={filterMutuelle}
                    onChange={(e) => setFilterMutuelle(e.target.value)}
                    size="sm"
                    style={{ borderRadius: "10px", flex: 2 }}
                  >
                    <option value="all">Mutuelle (byose)</option>
                    <option value="yishyuwe">Yishyuwe</option>
                    <option value="oya">Ntabwo yishyuwe</option>
                  </Form.Select>
                  <Form.Select
                    value={insuranceYear}
                    onChange={(e) => setInsuranceYear(Number(e.target.value))}
                    size="sm"
                    style={{ borderRadius: "10px", flex: 1 }}
                  >
                    {insuranceYearOptions.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </div>

            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                className="flex-fill"
                onClick={clearAllFilters}
                style={{
                  borderRadius: "12px",
                  minHeight: "44px",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                <i className="bi bi-x-lg me-1"></i>Siba Byose
              </Button>
              <Button
                variant="primary"
                className="flex-fill"
                onClick={() => setShowMobileFilters(false)}
                style={{
                  borderRadius: "12px",
                  minHeight: "44px",
                  background: theme.primary,
                  border: "none",
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                <i className="bi bi-check-lg me-1"></i>Emeza
              </Button>
            </div>
          </div>
        </>
      )}

      {/* ═══════════ DATA DISPLAY ═══════════ */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner
            animation="border"
            style={{
              color: theme.primary,
              width: isSmall ? "2rem" : "3rem",
              height: isSmall ? "2rem" : "3rem",
            }}
          />
          <p
            className="mt-3"
            style={{
              color: theme.textMuted,
              fontSize: isSmall ? "0.78rem" : "0.88rem",
            }}
          >
            Gutegura amakuru...
          </p>
        </div>
      ) : current.length === 0 ? (
        <div
          className="empty-state text-center"
          style={{ padding: isSmall ? "2rem 0.75rem" : "3rem" }}
        >
          <i
            className="bi bi-house-slash-fill"
            style={{
              fontSize: isSmall ? "2.5rem" : "4rem",
              color: "#cbd5e1",
            }}
          ></i>
          <h4
            className="mt-3"
            style={{
              color: theme.textMuted,
              fontSize: isSmall ? "0.95rem" : "1.15rem",
            }}
          >
            Nta ngo zihari
          </h4>
          <p
            style={{
              color: theme.textMuted,
              fontSize: isSmall ? "0.72rem" : "0.82rem",
            }}
          >
            {searchTerm || activeFilterCount > 0
              ? "Hindura amahitamo kugira ubone ibisubizo"
              : "Tangira wandike urugo rushya"}
          </p>
          {(searchTerm || activeFilterCount > 0) && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={clearAllFilters}
              style={{ borderRadius: "10px", marginTop: "0.4rem" }}
            >
              <i className="bi bi-x-lg me-1"></i>Siba amahitamo
            </Button>
          )}
        </div>
      ) : (
        <>
          {/* ── MOBILE CARD VIEW ── */}
          {isMobile && useCardView ? (
            <div>
              <div
                style={{
                  fontSize: "0.65rem",
                  color: theme.textMuted,
                  marginBottom: "0.4rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  fontWeight: 600,
                }}
              >
                {filteredData.length} ingo
              </div>
              {current.map((h, idx) => renderMobileCard(h, idx))}
            </div>
          ) : (
            /* ── TABLE VIEW ── */
            <div className="modern-table-wrapper" ref={tableRef}>
              <div className="table-scroll-wrapper">
                <Table hover className="modern-table">
                  <thead>
                    <tr>
                      <th className="text-center" style={{ minWidth: "40px" }}>
                        #
                      </th>
                      <th style={{ minWidth: "150px" }}>Umukuru w'Urugo</th>
                      <th style={{ minWidth: "120px" }}>Telefoni</th>
                      <th className="text-center" style={{ minWidth: "70px" }}>
                        Abagize
                      </th>
                      <th style={{ minWidth: "110px" }}>Umudugudu</th>
                      <th style={{ minWidth: "110px" }}>Isibo</th>
                      <th className="text-center" style={{ minWidth: "80px" }}>
                        Amazi
                      </th>
                      <th className="text-center" style={{ minWidth: "100px" }}>
                        Amashanyarazi
                      </th>
                      <th className="text-center" style={{ minWidth: "90px" }}>
                        Ubudehe
                      </th>
                      <th className="text-center" style={{ minWidth: "170px" }}>
                        Ubwishingizi / Mutuelle
                      </th>
                      <th
                        className="text-center"
                        style={{ minWidth: isTablet ? "110px" : "130px" }}
                      >
                        Ibikorwa
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {current.map((h, i) => {
                      const ub =
                        ubudeheCategories.find(
                          (c) => c.value === h.icyiciro_cy_imibereho
                        ) || {};
                      return (
                        <tr key={h.urugo_id}>
                          <td
                            className="text-center"
                            style={{ color: theme.primary, fontWeight: 700 }}
                          >
                            {idxFirst + i + 1}
                          </td>
                          <td>
                            <div
                              className="fw-semibold"
                              style={{
                                color: theme.primary,
                                cursor: 'pointer',
                                textDecoration: 'underline dotted',
                                textUnderlineOffset: '3px',
                              }}
                              title="Kanda urebe/wongerehe abagize urugo"
                              onClick={() => openMembersModal(h)}
                            >
                              {h.umukuru_w_urugo}
                            </div>
                          </td>
                          <td>{h.telefone_umukuru || "—"}</td>
                          <td className="text-center">
                            <Badge
                              bg={savedMembers[h.urugo_id]?.length > 0 ? 'success' : 'primary'}
                              pill
                              style={{ cursor: 'pointer' }}
                              onClick={() => openMembersModal(h)}
                              title="Reba abagize"
                            >
                              {h.umubare_w_abagize}{savedMembers[h.urugo_id]?.length > 0 ? ' ✓' : ''}
                            </Badge>
                          </td>
                          <td>{h.umudugudu || "—"}</td>
                          <td>{h.izina_ry_isibo || "—"}</td>
                          <td className="text-center">
                            <Badge bg={getYegoOyaColor(h.bafite_amazi)} pill>
                              <i
                                className={`bi bi-${getYegoOyaIcon(
                                  h.bafite_amazi
                                )} me-1`}
                              ></i>
                              {getYegoOyaText(h.bafite_amazi)}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge
                              bg={getYegoOyaColor(
                                h.bafite_umuyoboro_wamashanyarazi
                              )}
                              pill
                            >
                              <i
                                className={`bi bi-${getYegoOyaIcon(
                                  h.bafite_umuyoboro_wamashanyarazi
                                )} me-1`}
                              ></i>
                              {getYegoOyaText(
                                h.bafite_umuyoboro_wamashanyarazi
                              )}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <Badge bg={ub.color || "secondary"} pill>
                              {ub.label || h.icyiciro_cy_imibereho || "—"}
                            </Badge>
                          </td>
                          <td className="text-center">
                            <div
                              style={{
                                display: "inline-flex",
                                flexDirection: "column",
                                gap: "6px",
                                alignItems: "stretch",
                                minWidth: "128px",
                              }}
                            >
                              {h.ubwishingizi ? (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    fontSize: "0.72rem",
                                    fontWeight: 600,
                                    color: theme.primary,
                                    background: theme.primaryLight,
                                    border: `1px solid ${theme.border}`,
                                    borderRadius: "999px",
                                    padding: "3px 10px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <i className="bi bi-shield-shaded" />
                                  {insuranceLabel(h)}
                                </span>
                              ) : (
                                <span style={{ color: theme.textMuted, fontSize: "0.8rem" }}>—</span>
                              )}
                              {mutuelleBadge(h) && (
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    fontSize: "0.7rem",
                                    fontWeight: 700,
                                    color: "#fff",
                                    background: mutuelleBadge(h).paid ? theme.success : theme.danger,
                                    borderRadius: "999px",
                                    padding: "3px 10px",
                                    whiteSpace: "nowrap",
                                    boxShadow: `0 1px 3px ${mutuelleBadge(h).paid ? "rgba(22,163,74,0.35)" : "rgba(220,38,38,0.35)"}`,
                                  }}
                                >
                                  <i
                                    className={`bi bi-${mutuelleBadge(h).paid ? "check-circle-fill" : "x-circle-fill"}`}
                                  />
                                  {mutuelleBadge(h).paid ? "Yishyuwe" : "Ntabwo yishyuwe"} · {insuranceYear}
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="text-center">
                            <div className="d-flex gap-1 justify-content-center">
                              <Button
                                className="btn-action btn-outline-info"
                                onClick={() => handleViewDetails(h)}
                              >
                                <i className="bi bi-eye"></i>
                              </Button>
                              <Button
                                className="btn-action btn-outline-primary"
                                onClick={() => handleEdit(h)}
                              >
                                <i className="bi bi-pencil"></i>
                              </Button>
                              <Button
                                className="btn-action btn-outline-danger"
                                onClick={() => openDeleteModal(h.urugo_id)}
                              >
                                <i className="bi bi-trash"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          )}

          {/* Pagination */}
          {renderPagination()}
        </>
      )}

      {/* ═══════════ MEMBERS MODAL ═══════════ */}
      <Modal
        show={showMembers}
        onHide={() => setShowMembers(false)}
        centered
        size={isMobile ? undefined : 'md'}
        fullscreen={isSmall ? true : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: isMobile ? '0.95rem' : '1.1rem' }}>
            <i className="bi bi-people-fill me-2" style={{ color: theme.primary }}></i>
            Abagize Umuryango
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {membersHousehold && (
            <>
              {/* Household head banner */}
              <div style={{
                background: 'linear-gradient(135deg, rgba(30,58,95,0.1), rgba(30,58,95,0.05))',
                border: '1px solid rgba(30,58,95,0.18)',
                borderRadius: '12px',
                padding: '0.65rem 1rem',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
                <div>
                  <div style={{ fontSize: '0.65rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Umukuru w'Urugo</div>
                  <div style={{ fontWeight: 700, color: theme.textBright, fontSize: isMobile ? '0.95rem' : '1rem' }}>
                    {membersHousehold.umukuru_w_urugo}
                  </div>
                </div>
                <Badge bg="primary" pill style={{ fontSize: '0.75rem' }}>
                  Abagize {memberNames.filter(n => n.trim()).length} / {memberNames.length}
                </Badge>
              </div>

              {membersLoading ? (
                <div className="text-center py-4">
                  <Spinner animation="border" size="sm" style={{ color: theme.primary }} />
                </div>
              ) : savedMembers[membersHousehold.urugo_id]?.length > 0 && memberNames.every(n => n.trim()) ? (
                /* ── VIEW MODE: show saved members with edit/delete ── */
                <>
                  <div style={{ fontSize: '0.78rem', color: theme.textMuted, marginBottom: '0.75rem' }}>Abagize Umuryango:</div>
                  {memberNames.map((name, i) => (
                    <div key={i} style={{
                      background: theme.bgSecondary,
                      border: `1px solid ${theme.border}`,
                      borderRadius: '10px',
                      padding: '0.6rem 0.85rem',
                      marginBottom: '0.4rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <div style={{
                          width: 26, height: 26, borderRadius: '50%',
                          background: 'rgba(30,58,95,0.12)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: '0.65rem', color: theme.primary, fontWeight: 700, flexShrink: 0,
                        }}>{i + 1}</div>
                        <span style={{ color: theme.textBright, fontSize: '0.88rem', fontWeight: 500 }}>{name}</span>
                      </div>
                      <Button
                        variant="link"
                        size="sm"
                        style={{ color: theme.primary, padding: 0, fontSize: '0.78rem' }}
                        onClick={() => {
                          // switch to edit mode by clearing saved state for this household
                          setSavedMembers(p => { const n = { ...p }; delete n[membersHousehold.urugo_id]; return n; });
                        }}
                      >
                        <i className="bi bi-pencil"></i>
                      </Button>
                    </div>
                  ))}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="w-100 mb-2"
                    style={{ borderRadius: '10px' }}
                    disabled={membersLoading}
                    onClick={() => { setMemberNames(prev => [...prev, '']); setMemberIds(prev => [...prev, null]); }}
                  >
                    <i className="bi bi-plus-lg me-1"></i>
                    Ongeraho undi munyamuryango
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="w-100 mt-2"
                    style={{ borderRadius: '10px' }}
                    disabled={membersLoading}
                    onClick={deleteMembers}
                  >
                    {membersLoading ? <Spinner size="sm" className="me-1" /> : <i className="bi bi-trash me-1"></i>}
                    Siba abagize
                  </Button>
                </>
              ) : (
                /* ── INPUT MODE: enter names ── */
                <>
                  <div style={{ fontSize: '0.78rem', color: theme.textMuted, marginBottom: '0.85rem' }}>
                    Andika amazina y'abagize urugo:
                  </div>
                  {memberNames.map((name, i) => (
                    <Form.Group key={i} className="mb-3">
                      <Form.Label style={{ fontSize: '0.75rem', color: theme.textMuted }}>
                        Umunyamuryango wa {i + 1}
                      </Form.Label>
                      <Form.Control
                        ref={i === 0 ? firstMemberRef : undefined}
                        value={name}
                        placeholder={`Izina rya ${i + 1}...`}
                        onChange={e => {
                          const updated = [...memberNames];
                          updated[i] = e.target.value;
                          setMemberNames(updated);
                        }}
                        style={{ background: theme.card, borderColor: name.trim() ? theme.primary : theme.border, color: theme.text, borderRadius: '10px' }}
                      />
                    </Form.Group>
                  ))}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="w-100 mb-2"
                    style={{ borderRadius: '10px' }}
                    onClick={() => { setMemberNames(prev => [...prev, '']); setMemberIds(prev => [...prev, null]); }}
                  >
                    <i className="bi bi-plus-lg me-1"></i>
                    Ongeraho undi munyamuryango
                  </Button>
                </>
              )}
            </>
          )}
        </Modal.Body>
        {/* Footer: only show save button in input mode */}
        {membersHousehold && !(savedMembers[membersHousehold.urugo_id]?.length > 0 && memberNames.every(n => n.trim())) && (
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowMembers(false)}
              style={{ borderRadius: '12px', minHeight: isMobile ? '44px' : 'auto' }}
            >
              Bireke
            </Button>
            <Button
              className="btn-primary-modern"
              onClick={saveMembers}
              disabled={membersLoading || memberNames.some(n => !n.trim())}
              style={{ minHeight: isMobile ? '44px' : 'auto' }}
            >
              {membersLoading ? <Spinner size="sm" className="me-1" /> : <i className="bi bi-floppy me-1"></i>}
              Bika Abagize Umuryango
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      {/* ═══════════ DELETE MODAL ═══════════ */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        size={isSmall ? "sm" : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {isSmall ? "Gusiba" : "Emeza Gusiba"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            className="mb-0"
            style={{ fontSize: isSmall ? "0.82rem" : "0.95rem" }}
          >
            Urashaka koko gusiba uru rugo?{" "}
            <strong>Iki gikorwa ntikigarurwa.</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              flex: isMobile ? 1 : "none",
            }}
          >
            Bireke
          </Button>
          <Button
            variant="danger"
            onClick={confirmDelete}
            disabled={loading}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              flex: isMobile ? 1 : "none",
            }}
          >
            {loading ? "Tegereza..." : "Emeza, Siba"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════ ADD/EDIT MODAL ═══════════ */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        size={isMobile ? undefined : "lg"}
        centered
        fullscreen={isSmall ? true : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i
              className={`bi bi-${
                editingId ? "pencil" : "house-add"
              }-fill me-2`}
              style={{ color: theme.primary }}
            ></i>
            {editingId
              ? isSmall
                ? "Hindura"
                : "Hindura Amakuru y'Urugo"
              : isSmall
              ? "Andika Urugo"
              : "Andika Urugo Rushya"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Amazina y'Umukuru w'Urugo *</Form.Label>
                  <Form.Control
                    name="umukuru_w_urugo"
                    value={form.umukuru_w_urugo}
                    onChange={handleInputChange}
                    isInvalid={!!formErrors.umukuru_w_urugo}
                    autoComplete="name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.umukuru_w_urugo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Umubare w'Abagize *</Form.Label>
                  <Form.Control
                    type="number"
                    name="umubare_w_abagize"
                    value={form.umubare_w_abagize}
                    onChange={handleInputChange}
                    min="1"
                    isInvalid={!!formErrors.umubare_w_abagize}
                    inputMode="numeric"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.umubare_w_abagize}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Telefoni y'Umukuru w'Umuryango</Form.Label>
                  <Form.Control
                    name="telefone_umukuru"
                    value={form.telefone_umukuru}
                    onChange={handleInputChange}
                    placeholder="07XXXXXXXX"
                    inputMode="tel"
                    autoComplete="tel"
                    isInvalid={!!formErrors.telefone_umukuru}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.telefone_umukuru}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Indangamuntu y'Umukuru w'Umuryango</Form.Label>
                  <Form.Control
                    name="indangamuntu_umukuru"
                    value={form.indangamuntu_umukuru}
                    onChange={handleInputChange}
                    maxLength={16}
                    inputMode="numeric"
                    isInvalid={!!formErrors.indangamuntu_umukuru}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.indangamuntu_umukuru}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Aho Batuye</Form.Label>
                  <Form.Control
                    name="aho_batuye"
                    value={form.aho_batuye}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Ubwoko bw'Inzu</Form.Label>
                  <Form.Select
                    name="ubwoko_bw_inzu"
                    value={form.ubwoko_bw_inzu}
                    onChange={handleInputChange}
                  >
                    <option value="">Hitamo...</option>
                    <option value="Iyabo">Iyabo</option>
                    <option value="Ikodeshejwe">Ikodeshejwe</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Bafite Amazi</Form.Label>
                  <Form.Select
                    name="bafite_amazi"
                    value={form.bafite_amazi}
                    onChange={handleInputChange}
                  >
                    <option value="">Hitamo...</option>
                    <option value="Yego">Yego</option>
                    <option value="Oya">Oya</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Amashanyarazi</Form.Label>
                  <Form.Select
                    name="bafite_umuyoboro_wamashanyarazi"
                    value={form.bafite_umuyoboro_wamashanyarazi}
                    onChange={handleInputChange}
                  >
                    <option value="">Hitamo...</option>
                    <option value="Yego">Yego</option>
                    <option value="Oya">Oya</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Imibereho</Form.Label>
                  <Form.Select
                    name="icyiciro_cy_imibereho"
                    value={form.icyiciro_cy_imibereho}
                    onChange={handleInputChange}
                  >
                    <option value="">Hitamo...</option>
                    {ubudeheCategories.map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Izina ry'Isibo Urugo Rurimo</Form.Label>
                  <Form.Control
                    name="izina_ry_isibo"
                    value={form.izina_ry_isibo}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Ubwishingizi Urugo Rukoresha</Form.Label>
                  <Form.Select
                    name="ubwishingizi"
                    value={form.ubwishingizi}
                    onChange={handleInputChange}
                    disabled={isUmudugudu}
                  >
                    <option value="">Hitamo ubwishingizi...</option>
                    {INSURANCE_TYPES.map((t) => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            {form.ubwishingizi === "Ibindi" && (
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Andika ubundi bwoko bw'ubwishingizi</Form.Label>
                    <Form.Control
                      name="ubwishingizi_bwihariye"
                      value={form.ubwishingizi_bwihariye}
                      onChange={handleInputChange}
                      placeholder="Urugero: Old Mutual, Sanlam..."
                      disabled={isUmudugudu}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            {form.ubwishingizi === "Mituweli" && (
              <Row>
                <Col xs={12}>
                  <div
                    style={{
                      background: theme.successLight,
                      border: `1px solid ${theme.border}`,
                      borderRadius: "10px",
                      padding: "0.75rem 1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    {editingId && !isUmudugudu ? (
                      <Form.Check
                        type="checkbox"
                        id="mutuelle-paid-check"
                        checked={mutuellePaid}
                        onChange={(e) => setMutuellePaid(e.target.checked)}
                        label={
                          <span style={{ fontWeight: 600, color: theme.textBright }}>
                            <i className="bi bi-shield-check me-1" style={{ color: theme.success }}></i>
                            Mituweli yishyuwe kuri {insuranceYear}
                          </span>
                        }
                      />
                    ) : editingId && isUmudugudu ? (
                      <span style={{ fontSize: "0.85rem", color: theme.textMuted }}>
                        <i className="bi bi-eye me-1"></i>
                        Mituweli {insuranceYear}:{" "}
                        <strong>{mutuellePaid ? "Yishyuwe" : "Ntabwo Yishyuwe"}</strong>
                        {" "}(umuyobozi w'Isibo ni we uyihindura)
                      </span>
                    ) : (
                      <span style={{ fontSize: "0.85rem", color: theme.textMuted }}>
                        <i className="bi bi-info-circle me-1"></i>
                        Bika urugo mbere, hanyuma urebe amakuru y'urugo kugira ngo ushyireho ko Mituweli yishyuwe.
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Umudugudu</Form.Label>
                  <Form.Control
                    name="umudugudu"
                    value={form.umudugudu}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Akagari</Form.Label>
                  <Form.Control
                    name="akagari"
                    value={form.akagari}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div
              className="d-flex gap-2 mt-3"
              style={{
                flexDirection: isMobile ? "column" : "row",
                justifyContent: isMobile ? "stretch" : "flex-end",
              }}
            >
              <Button
                variant="secondary"
                onClick={() => setShow(false)}
                style={{
                  borderRadius: "12px",
                  minHeight: isMobile ? "48px" : "auto",
                  order: isMobile ? 2 : 1,
                }}
              >
                <i className="bi bi-x-lg me-2"></i>Hagarika
              </Button>
              <Button
                type="submit"
                className="btn-primary-modern"
                disabled={loading}
                style={{
                  minHeight: isMobile ? "48px" : "auto",
                  order: isMobile ? 1 : 2,
                }}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Tegereza...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-lg me-2"></i>
                    {editingId ? "Vugurura" : "Bika"}
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ═══════════ DETAILS MODAL ═══════════ */}
      <Modal
        show={showDetails}
        onHide={() => setShowDetails(false)}
        size={isMobile ? undefined : "lg"}
        centered
        fullscreen={isSmall ? true : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i
              className="bi bi-house-fill me-2"
              style={{ color: theme.primary }}
            ></i>
            {isSmall ? "Amakuru" : "Amakuru Arambuye y'Urugo"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedHousehold && (
            <div>
              {/* Header Card */}
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "1.25rem",
                  padding: isSmall ? "0.75rem" : "1rem",
                  background:
                    `linear-gradient(145deg, ${theme.card} 0%, ${theme.bgSecondary} 100%)`,
                  borderRadius: "16px",
                  border: `1px solid ${theme.border}`,
                }}
              >
                <div
                  style={{
                    width: isSmall ? "45px" : "55px",
                    height: isSmall ? "45px" : "55px",
                    borderRadius: "50%",
                    background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 0.6rem",
                    fontSize: isSmall ? "1.15rem" : "1.35rem",
                    color: "#fff",
                  }}
                >
                  <i className="bi bi-house-fill"></i>
                </div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: isSmall ? "0.95rem" : "1.1rem",
                    color: theme.textBright,
                  }}
                >
                  {selectedHousehold.umukuru_w_urugo}
                </div>
                <div className="d-flex gap-2 justify-content-center mt-2 flex-wrap">
                  <Badge bg="primary" pill>
                    <i className="bi bi-people-fill me-1"></i>
                    {selectedHousehold.umubare_w_abagize} abagize
                  </Badge>
                  {selectedHousehold.icyiciro_cy_imibereho && (
                    <Badge
                      bg={
                        ubudeheCategories.find(
                          (c) =>
                            c.value ===
                            selectedHousehold.icyiciro_cy_imibereho
                        )?.color || "secondary"
                      }
                      pill
                    >
                      {selectedHousehold.icyiciro_cy_imibereho}
                    </Badge>
                  )}
                </div>
              </div>

              {/* Details Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr",
                  gap: "0.75rem",
                }}
              >
                {[
                  {
                    label: "Telefoni y'Umukuru",
                    value: selectedHousehold.telefone_umukuru || "—",
                    icon: "telephone",
                  },
                  {
                    label: "Indangamuntu y'Umukuru",
                    value: selectedHousehold.indangamuntu_umukuru || "—",
                    icon: "credit-card",
                  },
                  {
                    label: "Izina ry'Isibo",
                    value: selectedHousehold.izina_ry_isibo || "—",
                    icon: "diagram-3",
                  },
                  {
                    label: "Ubwishingizi",
                    value: insuranceLabel(selectedHousehold),
                    icon: "shield-check",
                  },
                  {
                    label: "Aho Batuye",
                    value: selectedHousehold.aho_batuye || "—",
                    icon: "geo-alt",
                  },
                  {
                    label: "Ubwoko bw'Inzu",
                    value: selectedHousehold.ubwoko_bw_inzu || "—",
                    icon: "house",
                  },
                  {
                    label: "Bafite Amazi",
                    value: getYegoOyaText(selectedHousehold.bafite_amazi),
                    icon: "droplet",
                    badge: true,
                    badgeColor: getYegoOyaColor(
                      selectedHousehold.bafite_amazi
                    ),
                  },
                  {
                    label: "Amashanyarazi",
                    value: getYegoOyaText(
                      selectedHousehold.bafite_umuyoboro_wamashanyarazi
                    ),
                    icon: "lightning-charge",
                    badge: true,
                    badgeColor: getYegoOyaColor(
                      selectedHousehold.bafite_umuyoboro_wamashanyarazi
                    ),
                  },
                  {
                    label: "Umudugudu",
                    value: selectedHousehold.umudugudu || "—",
                    icon: "pin-map",
                  },
                  {
                    label: "Akagari",
                    value: selectedHousehold.akagari || "—",
                    icon: "map",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    style={{
                      padding: "0.65rem",
                      background: theme.bgSecondary,
                      borderRadius: "12px",
                      border: `1px solid ${theme.border}`,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.4rem",
                        marginBottom: "0.25rem",
                      }}
                    >
                      <i
                        className={`bi bi-${item.icon}`}
                        style={{
                          color: theme.textMuted,
                          fontSize: "0.75rem",
                        }}
                      ></i>
                      <span
                        style={{
                          fontSize: "0.65rem",
                          color: theme.textMuted,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          fontWeight: 600,
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: isSmall ? "0.82rem" : "0.9rem",
                        color: theme.text,
                        fontWeight: 500,
                      }}
                    >
                      {item.badge ? (
                        <Badge bg={item.badgeColor} pill>
                          <i
                            className={`bi bi-${
                              item.badgeColor === "success"
                                ? "check-circle-fill"
                                : "x-circle-fill"
                            } me-1`}
                          ></i>
                          {item.value}
                        </Badge>
                      ) : (
                        item.value
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Mutuelle payment status — only for households insured via Mituweli */}
              {selectedHousehold.ubwishingizi === "Mituweli" && (
                <div
                  style={{
                    marginTop: "1rem",
                    padding: "0.85rem 1rem",
                    background: selectedHousehold.mutuelle_yishyuwe
                      ? theme.successLight
                      : theme.dangerLight,
                    border: `1px solid ${theme.border}`,
                    borderRadius: "12px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                      <div style={{ fontWeight: 700, color: theme.textBright }}>
                        <i className="bi bi-shield-check me-1"></i>
                        Mutuelle {insuranceYear}:{" "}
                        <span style={{ color: selectedHousehold.mutuelle_yishyuwe ? theme.success : theme.danger }}>
                          {selectedHousehold.mutuelle_yishyuwe ? "Yishyuwe" : "Ntabwo Yishyuwe"}
                        </span>
                      </div>
                      {selectedHousehold.mutuelle_yishyuwe && (
                        <div style={{ fontSize: "0.78rem", color: theme.textMuted, marginTop: "0.25rem" }}>
                          {selectedHousehold.mutuelle_itariki && (
                            <span className="me-3">
                              <i className="bi bi-calendar-check me-1"></i>
                              {new Date(selectedHousehold.mutuelle_itariki).toLocaleDateString("rw-RW")}
                            </span>
                          )}
                          {selectedHousehold.mutuelle_wanditse && (
                            <span>
                              <i className="bi bi-person me-1"></i>
                              {selectedHousehold.mutuelle_wanditse}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    {!isUmudugudu && (
                      <Button
                        size="sm"
                        variant={selectedHousehold.mutuelle_yishyuwe ? "outline-danger" : "success"}
                        onClick={() => toggleMutuelleFromDetails(selectedHousehold)}
                        style={{ borderRadius: "10px" }}
                      >
                        <i className={`bi bi-${selectedHousehold.mutuelle_yishyuwe ? "x-circle" : "check-circle"} me-1`}></i>
                        {selectedHousehold.mutuelle_yishyuwe
                          ? `Kuraho ishyuwe rya ${insuranceYear}`
                          : `Shyiraho ko yishyuwe ${insuranceYear}`}
                      </Button>
                    )}
                  </div>
                  {isUmudugudu && (
                    <div style={{ fontSize: "0.72rem", color: theme.textMuted, marginTop: "0.4rem" }}>
                      <i className="bi bi-eye me-1"></i>
                      Umuyobozi w'Umudugudu areba gusa — umuyobozi w'Isibo ni we uhindura iri shyuwe.
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{ flexDirection: isMobile ? "column" : "row" }}
        >
          {selectedHousehold && (
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowDetails(false);
                handleEdit(selectedHousehold);
              }}
              style={{
                borderRadius: "12px",
                minHeight: isMobile ? "44px" : "auto",
                width: isMobile ? "100%" : "auto",
                WebkitTapHighlightColor: "transparent",
              }}
            >
              <i className="bi bi-pencil me-2"></i>Hindura
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => setShowDetails(false)}
            style={{
              borderRadius: "12px",
              minHeight: isMobile ? "44px" : "auto",
              width: isMobile ? "100%" : "auto",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            <i className="bi bi-x-lg me-2"></i>Funga
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Ingo;